import './products.scss'
const Products = () => {
  return (
    <div className="products">Products</div>
  )
}
export default Products;